// Unités de soins : référentiel tenu par be_stock, géré depuis les Paramètres de la Clinique.
import StockApi from '@/api/stock/api_stock'

const base = '/v1/settings/hospital-services'

export default {
    liste() {
        return StockApi().get(base).then(response => response.data.data || [])
    },

    armoires() {
        return StockApi().get('/stocks').then(response => (response.data || []).filter(stock => !stock.deleted_at))
    },

    enregistrer(unite) {
        const payload = Object.assign({}, unite)
        delete payload.id
        return unite.id ? StockApi().put(base + '/' + unite.id, payload) : StockApi().post(base, payload)
    },

    affectations(userId) {
        return StockApi().get(base + '/users/' + userId).then(response => response.data.data || [])
    },

    affecter(userId, serviceIds, primaryServiceId) {
        return StockApi().put(base + '/users/' + userId, { service_ids: serviceIds, primary_service_id: primaryServiceId })
    },

    // Message lisible d'un refus du serveur (désactivation bloquée, code déjà pris…).
    messageErreur(error) {
        const data = error && error.response && error.response.data
        if (data && data.message) return data.message
        if (data && data.errors) return [].concat.apply([], Object.values(data.errors)).join(' · ')
        return 'Le référentiel des unités de soins ne répond pas. Réessayez.'
    }
}
